import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "12px 0",
    fontFamily: "'Inter', sans-serif",
  },
  tableWrapper: {
    width: "100%",
    backgroundColor: "#ffffff",
    borderRadius: "8px",
    overflow: "hidden",
    border: "1px solid #f1f5f9",
  },
  tableHeaderRow: {
    backgroundColor: "#f8fafc",
  },
  tableHeaderCell: {
    fontSize: "12px !important",
    fontWeight: "600 !important",
    color: "#475569 !important",
    textTransform: "uppercase",
    letterSpacing: "0.05em",
    fontFamily: "'Inter', sans-serif !important",
    borderBottom: "1px solid #f1f5f9 !important",
    padding: "16px 20px !important",
  },
  tableRow: {
    transition: "background-color 0.2s",
    "&:hover": {
      backgroundColor: "#f8fafc",
    },
  },
  tableCell: {
    fontSize: "14px !important",
    color: "#334155 !important",
    fontFamily: "'Inter', sans-serif !important",
    borderBottom: "1px solid #f1f5f9 !important",
    padding: "16px 20px !important",
  },
  boldText: {
    fontWeight: "700 !important",
    color: "#0f172a !important",
  },
  actionBtnWrapper: {
    display: "flex",
    gap: "10px",
  },
  uploadButton: {
    backgroundColor: "#1a1a1a !important",
    color: "#ffffff !important",
    textTransform: "none !important",
    borderRadius: "8px !important",
    padding: "6px 16px !important",
    fontWeight: "600 !important",
    fontFamily: "'Inter', sans-serif !important",
    "&:hover": {
      backgroundColor: "#333333 !important",
    },
  },
  viewButton: {
    backgroundColor: "#ffffff !important",
    color: "#374151 !important",
    textTransform: "none !important",
    borderRadius: "8px !important",
    padding: "6px 16px !important",
    fontWeight: "600 !important",
    fontFamily: "'Inter', sans-serif !important",
    border: "1px solid #e5e7eb !important",
    "&:hover": {
      backgroundColor: "#f9fafb !important",
    },
  },
  deleteButton: {
    backgroundColor: "#ef4444 !important",
    color: "#ffffff !important",
    textTransform: "none !important",
    borderRadius: "8px !important",
    padding: "6px 16px !important",
    fontWeight: "600 !important",
    fontFamily: "'Inter', sans-serif !important",
    "&:hover": {
      backgroundColor: "#dc2626 !important",
    },
  },
  statusBadge: {
    display: "inline-flex",
    alignItems: "center",
    padding: "4px 12px",
    borderRadius: "100px",
    fontSize: "12px",
    fontWeight: "600",
    textTransform: "uppercase",
  },
  statusNoDocument: {
    backgroundColor: "#fee2e2",
    color: "#ef4444",
  },
  statusUploaded: {
    backgroundColor: "#d1fae5",
    color: "#10b981",
  },
  statusPending: {
    backgroundColor: "#fef3c7",
    color: "#d97706",
  },
}));

export default useStyles;
